import script from "./Game.vue?vue&type=script&setup=true&lang=js"
export * from "./Game.vue?vue&type=script&setup=true&lang=js"

import "./Game.vue?vue&type=style&index=0&id=349a835a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-349a835a"]])

export default __exports__